<template>
  <el-dialog
    v-if="visibles"
    :visible.sync="visibles"
      v-el-drag-dialog
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    top="5vh"
    width="60%"
    center
  >
    <dialog-header
      slot="title"
      :title="$t('carMonitor.terminalBatch.add')"
      @close="closeDialog"
    />
    <div style="height: 70vh">
      <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
      
    <vue-linetitle :title="$t('public.taskInformation')" :icon-config="{icon: 'taskInformation'}">
      <el-row type="flex" justify="start" align="top">
        <el-col :span="12">
          <el-form   ref="taskform" :rules="rulesCenter" :model="formInfo" :label-position="'right'" :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')">
            <el-form-item :label="$t('carMonitor.terminalBatch.taskName')+'：'" prop="operationname">
              <el-input v-model="formInfo.operationname" :placeholder="$t('carMonitor.terminalBatch.taskName')" clearable />
            </el-form-item>
            <el-form-item style="margin-bottom: 0 !important"  :label="$t('carMonitor.terminalBatch.remark')+'：'">
              <el-input
                v-model.trim="formInfo.remark"
                resize="none"
                :placeholder="$t('carMonitor.terminalBatch.remark')"/>
              
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </vue-linetitle>

    <vue-linetitle :title="$t('public.command')" :icon-config="{icon: 'command'}">
        <el-table
         :row-class-name="isCell ? setCellClass : ''" 
          :row-style="rowStyle"
          ref="tableList"
          show-overflow-tooltip
          size="mini"
          :data="list"
          border
          fit
          highlight-current-row
          :show-header="false"
          @select="rowSelect"
          :span-method="objectSpanMethod"
          style="width: 100%">
          <el-table-column
            type="selection"
            width="55"
            align="center"/>
          <el-table-column
            :label="'label'"
            prop="value"
            align="left">
            <template slot-scope="scope">
              <!-- <div>{{ scope.row['commandname'] }}</div> -->
              <!-- 端口域名 -->
              <div v-if="scope.row['type']==1">
                <el-form ref="command1" :show-message="false" :inline="true" :rules="rulesCenter" :model="commandInfo" class="demo-form-inline" >
                  <el-form-item 
                   :label-width="$t('carMonitor.terminalBatch.commandWdith')"
                   style="margin-bottom: 0 !important" 
                  :label="$t('public.IPorDomain')+'：'" 
                  prop="url"
                  :rules="rulesFun(scope.row.reg1,scope.row.error1)">
                    <el-input :disabled="findChecked(scope.row['type'])" v-model="commandInfo.url" :placeholder="$t('public.IPorDomain')"></el-input>
                  </el-form-item>
                  <el-form-item 
                   style="margin-bottom: 0 !important"
                  :label="scope.row['commandname'].split(',')[1]+'：'" 
                  :rules="rulesFun(scope.row.reg2,scope.row.error2)"
                  prop="port">
                    <el-input style="width: 70px" :disabled="findChecked(scope.row['type'])" v-model="commandInfo.port" :placeholder="scope.row['commandname'].split(',')[1]"></el-input>
                  </el-form-item>
                   <span style="line-height: 32px">0-65535</span>
                </el-form>
               

              </div>
              <!-- 三轴唤醒阈值 -->
              <div v-else-if="scope.row['type']==2">
                <el-form ref="command2" :show-message="false" :inline="true" :model="commandInfo" :rules="rulesCenter" class="demo-form-inline">
                  <el-form-item 
                  :label-width="$t('carMonitor.terminalBatch.commandWdith')"
                  style="margin-bottom: 0 !important"
                  :rules="rulesFun(scope.row.reg1,scope.row.error1)" 
                  :label="scope.row['commandname']+'：'" prop="threshold">
                    <el-input style="width: 70px" :disabled="findChecked(scope.row['type'])" v-model="commandInfo.threshold" ></el-input>
                  </el-form-item>
                  <span style="line-height: 32px">{{ scope.row['error1'] }}</span>
                </el-form>
              </div>
              <!-- 定时唤醒时间 -->
              <div v-else-if="scope.row['type']==3">
                <el-form ref="command3" :show-message="false" :inline="true" :model="commandInfo" :rules="rulesCenter" class="demo-form-inline">
                  <el-form-item
                   :label-width="$t('carMonitor.terminalBatch.commandWdith')"
                    style="margin-bottom: 0 !important" :rules="rulesFun(scope.row.reg1,scope.row.error1)" :label="scope.row['commandname']+'：'" prop="time">
                    <el-input style="width: 70px" :disabled="findChecked(scope.row['type'])" v-model="commandInfo.time" ></el-input>
                  </el-form-item>
                  <span style="line-height: 32px">{{ scope.row['error1'] }}</span>
                </el-form>

                
              </div>
              <!-- 定时唤醒保持时间 -->
              <div v-else-if="scope.row['type']==4">
                <el-form ref="command4" :show-message="false" :inline="true" :model="commandInfo" :rules="rulesCenter" class="demo-form-inline">
                  <el-form-item
                   :label-width="$t('carMonitor.terminalBatch.commandWdith')"
                    style="margin-bottom: 0 !important" :rules="rulesFun(scope.row.reg1,scope.row.error1)" :label="scope.row['commandname']+'：'" prop="time2">
                    <el-input style="width: 70px" :disabled="findChecked(3)" v-model="commandInfo.time2" ></el-input>
                  </el-form-item>
                  <span style="line-height: 32px">{{ scope.row['error1'] }}</span>
                </el-form>
              </div>
              <!-- 远程IO -->
              <div v-else-if="scope.row['type']==5">
                  <span style="color: #F56C6C;margin-right: 4px">*</span>IO：
                  <div 
                  v-for="(item,index) in new Array(4)"
                  :key="index"
                  style="padding: 0 10px;display:inline-block">
                    <el-switch
                    :disabled="findChecked(scope.row['type'])"
                    v-model="commandInfo['IO'+(index+1)]"
                    :inactive-text="'IO'+(index+1)">
                    </el-switch>
                  </div> 
                  &nbsp;
                  <span style="line-height: 32px">{{ `${$t('public.close')} | ${$t('public.opens')}` }}</span>
              </div>
              <!-- 支持休眠 -->
              <div v-else-if="scope.row['type']==6">
                <span style="color: #F56C6C;margin-right: 4px">*</span>{{ scope.row['commandname'] }}：
                <!-- <el-checkbox :disabled="findChecked(scope.row['type'])" v-model="commandInfo.sleep">支持休眠</el-checkbox> -->
                <el-radio :disabled="findChecked(scope.row['type'])" v-model="commandInfo.sleep" :label="0">
                  <span>{{ $t('public.normalMode') }}</span></el-radio>
                <el-radio :disabled="findChecked(scope.row['type'])" v-model="commandInfo.sleep" :label="2">
                  <span>{{ $t('public.busSleep') }}</span></el-radio>
              </div>
               <!-- 远程IO2 -->
              <div v-else-if="scope.row['type']==7">
                  <span style="color: #F56C6C;margin-right: 4px">*</span>IO2：
                  <div 
                  v-for="(item,index) in new Array(2)"
                  :key="index"
                  style="padding: 0 10px;display:inline-block">
                    <el-switch
                    :disabled="findChecked(scope.row['type'])"
                    v-model="commandInfo['IO_'+(index+1)]"
                    :inactive-text="'IO'+(index+1)">
                    </el-switch>
                  </div> 
                  &nbsp;
                  <span style="line-height: 32px">{{ `${$t('public.close')} | ${$t('public.opens')}` }}</span>
              </div>
              <!-- 离线锁车 -->
              <div v-else-if="scope.row['type']==8">
                <span style="color: #F56C6C;margin-right: 4px">*</span>{{ scope.row['commandname'] }}：
                <!-- <el-checkbox :disabled="findChecked(scope.row['type'])" v-model="commandInfo.sleep">支持休眠</el-checkbox> -->
                <el-radio :disabled="findChecked(scope.row['type'])" v-model="commandInfo.lock" :label="1">
                  <span>{{ $t('public.lockCarOpen') }}</span></el-radio>
                <el-radio :disabled="findChecked(scope.row['type'])" v-model="commandInfo.lock" :label="0">
                  <span>{{ $t('public.cancelLockCar') }}</span></el-radio>
              </div>
            </template>
          </el-table-column>
        </el-table>
    </vue-linetitle>

    <vue-linetitle :title="$t('public.commandVehicle')" :icon-config="{icon: 'commandVehicle'}">
      <el-row type="flex" justify="start" align="top">
        <el-col :span="12">
          <el-form ref="carform" :rules="rulesCenter" :model="formInfo" :label-position="'right'" :label-width="$t('carMonitor.terminalBatch.searchWidth.width3')">
            <el-form-item :label="$t('carMonitor.terminalBatch.selectObd')+'：'" prop="car">
              <div style="position:relative;">
                <div style="width:100%;height:100%;position:absolute;top:0;left:0;z-index:999;cursor:pointer" @click="selectCarVisibles=true" />
                <div class="fl car-tag">
                  <el-scrollbar style="height:100%;" wrap-class="default-scrollbar__wrap">
                    <el-tag
                    style="margin: 0 5px"
                      v-for="(tag,index) in selectCarList"
                      :key="index"
                      closable
                      effect="plain"
                      :disable-transitions="false"
                      @close="handleClose(tag)">
                     <span>{{ tag.barcode }}</span>
                    </el-tag>
                  </el-scrollbar>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="3" style="margin-left: 20px" type="flex" align="start">
          <el-button type="primary" @click="selectCarVisibles=true">
            <svg-icon icon-class="icon-add" />
            {{ $t('public.chose') }}
          </el-button>
        </el-col>
        <el-col :span="2" type="flex" justify="center" align="center">
          <el-button type="primary" @click="importVisible=true">
             <svg-icon icon-class="icon-import" />
            {{ $t('carMonitor.terminalBatch.import') }}
          </el-button>
        </el-col>
       
      </el-row>
      
    </vue-linetitle>
    </el-scrollbar>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="handleCancel">{{ $t('carMonitor.terminalBatch.cancleBtn') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('carMonitor.terminalBatch.okBtn') }}</el-button>
    </span>
    <!-- 选择车辆 -->
    <select-obd-dialog
      :visibles.sync="selectCarVisibles"
      :data="selectCarList"
      @select-complete="selectCarComplete"
    />
    <!-- 导入 -->
    
    <import-dialog
      ref="importDialog"
      action="api/batchremotesetting/obdImport"
      :template-url="'file/upload/template/TerminalImportForCommandSetting.xlsx'"
      :append-to-body="true"
      :visibles.sync="importVisible"
      @upload-success="importCarComplete"
    />
    
  </el-dialog>
</template>

<script>
// 混入
import selectObdDialog from './selectObdDialog'
import importDialog from '@/components/importDialog'
// import selectCommondDialog from './selectCommondDialog'
import { createCommond, getCommandParam } from '@/api/carMonitor/terminalBatch'
import { duplicateRemoval } from '@/utils/base'
import { tableStyle } from '@/mixins/tableStyle'
import { IOLIST, IO2LIST } from '@/api/system/company'
// eslint-disable-next-line no-useless-escape
const urlReg = /^(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@@)|\/|\?)*)?$/i
const portReg = /^([0-9]|[1-9]\d|[1-9]\d{2}|[1-9]\d{3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5])$/

// request
export default {
  name: 'AddTaskDialog',
  components: { selectObdDialog, importDialog },
  mixins: [tableStyle],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatefaultcode = (rule, value, cb) => {
      if (value === '' || value === undefined) {
        return cb(new Error(this.$t('carMonitor.terminalBatch.tasknameTips')))
      }
    }
    const validateCar = (rule, value, cb) => {
      if (this.selectCarList.length === 0) {
        return cb(new Error(this.$t('carMonitor.terminalBatch.selectCarTips')))
      }
    }
    
    return {
      formInfo: {
        operationname: '',
        remark: ''
      },
      total: 0,
      list: [],
      listLoading: false,
      selectCarList: [],
      selectCarVisibles: false,
      selectCommondVisible: false,
      importVisible: false,
      rulesCenter: {
        operationname: [
          { required: true, trigger: ['blur', 'change'], validator: validatefaultcode }
        ],
        car: [
          { required: true, trigger: ['blur', 'change'], validator: validateCar }
        ]
      },
      commandInfo: {sleep: 0, lock: 0},
      selectionList: [],
      isCell: false
    }
  },
  created() {
    this._getCommandParam()
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    objectSpanMethod({row, column, rowIndex, columnIndex}) {
      
      if (columnIndex === 0) {
          if (rowIndex===2) {
            return {
              rowspan: 2,
              colspan: 1
            }
          }else if(rowIndex===3){
             return [0,0]
          }else{
            return [1,1]
          }
        }
    },
 

    rulesFun(reg, errorText) {
      const validate = (rule, value, cb) => {
        if (!reg.test(value)) {
          return cb(new Error(errorText))
        }
      }
      return [
        { required: true, trigger: ['blur', 'change'], validator: validate }
      ]
    },
    handleClose(tag) {
      this.selectCarList.splice(this.selectCarList.indexOf(tag), 1)
    },
    findChecked(type) {
      const index = this.selectionList.findIndex(v=>v===type)
      if(index>-1 ) return false
      return true
    },

    _getCommandParam() {
      getCommandParam().then(({data})=> {
        if(data.code===0) {
          const result = data.data || []
          this.list = result.map((item,index)=>{
            item.type=(index+1)
            const regArr = item.reservedfield2.split('\\n')
            const errTextArr = item.remark.split('；')
            if(regArr.length>1) {
              item.reg1 = urlReg
              item.error1 = errTextArr[0]
              item.reg2 = portReg
              item.error2 = errTextArr.length > 1 ? errTextArr[1] : ''
            }else{
              item.reg1 = new RegExp(item.reservedfield2)
              item.error1 = errTextArr[0]
            }
            return item
          })
        }
      })
    },
    selectCarComplete(e) {
      this.selectCarList = duplicateRemoval([...e], 'barcode')
      this.$refs.carform.validate((vaild) => {
        if (!vaild) {
          // check2 = false
        }
      })
    },

    importCarComplete(e) {
      const resultSuccess = e.successList || []
      const successList = resultSuccess.map(item=>{return {barcode: item}})
      this.selectCarList = duplicateRemoval([...this.selectCarList, ...successList], 'barcode')
      this.$refs.importDialog.closeDialog()
    },

    handleClear() {
      this.selectCarList = []
    },
    // 重置数据
    restData() {
      this.total = 0
      this.selectCarList = []
      this.formInfo.remark = ''
      this.formInfo.operationname = ''
      this.commandInfo = {sleep: 0, lock: 0}
      this.selectionList = []
    },
    // 关闭dialog
    closeDialog() {
      this.restData()
      this.$emit('update:visibles', false)
    },
    // 点击取消
    handleCancel() {
      this.closeDialog()
    },
    submitForm() {
      
      let check1 = true
      this.$refs.taskform.validate((vaild) => {
        if (!vaild) {
          check1 = false
        }
      })
      let check2 = true
      this.$refs.carform.validate((vaild) => {
        if (!vaild) {
          check2 = false
        }
      })
      
      let command1 = true
      if(this.selectionList.indexOf(1)>-1) {
        this.$refs['command1'].validate((valid) => {
          if (!valid) {
            command1 = false
          }
        })
      }
      let command2 = true
      if(this.selectionList.indexOf(2)>-1) {
        this.$refs['command2'].validate((valid) => {
          if (!valid) {
            command2 = false
          }
        })
      }
      // 列3，4由合并后的列3控制
      // begin
      let command3 = true
      let command4 = true
      if(this.selectionList.indexOf(3)>-1) {
        this.$refs['command3'].validate((valid) => {
          if (!valid) {
            command3 = false
          }
        })

        this.$refs['command4'].validate((valid) => {
          if (!valid) {
            command4 = false
          }
        })
      }
      // end
      if (!check1 || !check2 || !command1 || !command2 || !command3 || !command4) {
        return
      }
      if(this.selectionList.length===0) {
        this.$message.error({
          message: this.$t('public.noCommad'),
          duration: 2 * 1000
        })
        return
      }
      if(this.selectionList.indexOf(5)>-1) {
        if(this.commandInfo.sleep===undefined) {
          this.$message.error({
            message: this.$t('public.noNormalMode'),
            duration: 2 * 1000
          })
          return 
        }
      }

      const strcommandparams = []
      
      for(let i=0;i<this.selectionList.length;i++) {
        const param = this.getParams(this.selectionList[i])
        const index = this.list.findIndex(item=>item.type==this.selectionList[i])
        const commandid = this.list[index].oid
        strcommandparams.push({
          param,
          commandtype: 0,
          commandid 
        })
      }
      const postData = {
        operationname: this.formInfo.operationname,
        // commandname: this.selectCommond.packetname,
        // packetid: this.selectCommond.oid,
        caridlist: this.selectCarList.map(obj => obj.barcode).join(','),
        remark: this.formInfo.remark,
        maxexetimes: '3',
        strcommandparams: JSON.stringify(strcommandparams)
      }
      if (this.selectCarList.length === 0) {
        this.$message.error({
          message: this.$t('carMonitor.terminalBatch.selectCarTips'),
          duration: 2 * 1000
        })
        return
      }

      if(this.selectionList.indexOf(1)>-1) {
        this.$confirm(this.$t('public.confirmUrl'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
          type: 'warning'
        }).then(() => {
          this._createCommond(postData)
        }).catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // });          
        })
      }else{
        this._createCommond(postData)
      }
    },
    _createCommond(postData) {
      createCommond(postData).then(({ data }) => {
          if (data.code === 0) {
            this.$message.success({
              message: this.$t('carMonitor.terminalBatch.addSuccess'),
              duration: 2 * 1000
            })
            this.$emit('add-complete')
            this.closeDialog()
          }
        })
    },
    getParams(type) {
      const {
        port,
        url,
        threshold,
        time,
        time2,
        IO1:IO1=false,
        IO2:IO2=false,
        IO3:IO3=false,
        IO4:IO4=false,
        IO_1:IO_1=false,
        IO_2:IO_2=false,
        sleep,
        lock
      } = this.commandInfo
      let result = ''
      switch(type) {
        case 1:
          result = `${url},${port}`
          break
        case 2:
          result = threshold
          break
        case 3:
          result = time
          break
          case 4:
          result = time2
          break
        case 5:
          // eslint-disable-next-line no-case-declarations
          let io = [IO1,IO2,IO3,IO4]
          // eslint-disable-next-line no-case-declarations
          const index = IOLIST.findIndex(item=>JSON.stringify(item)===JSON.stringify(io))
          result = index
         break
        case 6:
          result = sleep
          break
        case 7:
           // eslint-disable-next-line no-case-declarations
          let io2 = [IO_1,IO_2]
          // eslint-disable-next-line no-case-declarations
          const index2 = IO2LIST.findIndex(item=>JSON.stringify(item)===JSON.stringify(io2))
          result = index2
          break
        case 8:
          result = lock
      }
      return result
    },
    rowSelect(selection) {
      for(let i=1;i<5;i++) {
        this.$refs['command' + i].clearValidate()
      }
      this.selectionList = (selection||[]).map(item=>item.type)
      if(this.selectionList.indexOf(3)>-1) {
        this.selectionList.push(4)
      }

    }

  }
}

</script>

<style lang="scss" scoped>
.search_list{
  padding-top:0
}
.fl{
  float: left;
}
.car-tag{
  width: calc(100%);
  height: 100px;
  border: 1px dashed #ddd;
  padding:3px;
  .numberPlate{
    margin:5px 0;
    span{
      font-weight: bold;
    }
  }
}
.car-add-btn{
  float: right;
  margin-top:10px;
  .el-button+.el-button{
    margin: 20px 0 0
  }
}
.cellClass {
    .el-table-column--selection {
      background-color: #ebf7ff;
    }
  }
</style>
